import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IProps {
  edit?: boolean;
  marginTop?: string;
  marginLeft?: string;
  disabled?: boolean;
  topValue?: string;
  rightValue?: string;
}


interface IGeneratorBoxProps {
  drawBox: boolean;
}

export const Root = styled.div`
  position: absolute;
  width: 200px;
  top: ${(props: IProps) => (props.topValue ?? `-60px`)};
  right: ${(props: IProps) => (props.rightValue ?? `auto`)};
  z-index: 100;
`
export const Row = styled.div`
    width: 100%;
    border-radius: 5px;
    background-color: #FFFFFF;
    box-shadow: ${(props: IGeneratorBoxProps) => props.drawBox ? "4px 4px 20px 2px rgba(0, 0, 0, 0.1)" : ""};
    padding: ${(props: IGeneratorBoxProps) => props.drawBox ? "12px 12px 12px 12px" : "0px 0px 0px 0px"};
    margin: auto;
    margin-top: 8px;
    margin-bottom: 8px;
    display: block;
    text-align: center; 
`;

export const ColorGeneratorButton = styled.div`
    width: 125px;
    height: 36px;
    display: flex;
    align-items: center;
    background-color: ${(props: IProps) => props.disabled ? C.GRAY : "#366cc8"};
    cursor: pointer;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    border-radius: 5px;
    margin: auto;
    margin-top: 25px;
    margin-bottom: 10px;
    display: block;
    text-align: center; 
`;

export const ColorGeneratorButtonText = styled.span`
    font-family: Roboto;
    font-size: 14px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: ${(props: IProps) => props.disabled ? C.DARKEST_GRAY : "#FFFFFF"};
    width: 100%;
    height: 36px;
    line-height: 36px;
`;